module.exports = __webpack_public_path__ + "static/DMSans-Bold-97780ae610327843f38b8c284f07e591.woff2";